module.exports = __webpack_public_path__ + "static/img/detailjk.bc7fcca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailjk.jpg
// module id = BGXr
// module chunks = 6